import { render, staticRenderFns } from "./TabItemTemplate.vue?vue&type=template&id=0e9047b8&scoped=true&"
import script from "./TabItemTemplate.vue?vue&type=script&lang=js&"
export * from "./TabItemTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TabItemTemplate.vue?vue&type=style&index=0&id=0e9047b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9047b8",
  null
  
)

export default component.exports